import CompleteIcon from 'components/Icons/CompleteIcon';
import ErrorIcon from 'components/Icons/ErrorIcon';
import PartialErrorIcon from 'components/Icons/YellowDangerIcon';
import ProcessingIconStatus from 'components/Icons/ProcessingIconStatus';
import React, { FC } from 'react';

type StatusPillProps = {
  status: string;
};

const StatusPill: FC<StatusPillProps> = ({ status }) => {
  const isStatusComplete = 'Concluído';

  const isStatusError = 'Erro - Erro total';

  const isStatusErrorIndividual = 'Erro';

  const isStatusPartialError = 'Erro parcial';

  const isStatusProcessing = 'Em processamento';

  const renderBadget = () => {
    if (status === isStatusComplete) {
      return (
        <div className={`status complete-status`}>
          <CompleteIcon />
          <strong>Concluído</strong>
        </div>
      );
    }
    if (status === isStatusError || status === isStatusErrorIndividual) {
      return (
        <div className={`status error-status`}>
          <ErrorIcon />
          <strong>Erro</strong>
        </div>
      );
    }
    if (status === isStatusPartialError) {
      return (
        <div className={`status partial-error-status`}>
          <PartialErrorIcon />
          <strong>Erro parcial</strong>
        </div>
      );
    }
    if (status === isStatusProcessing) {
      return (
        <div className={`status processing-status`}>
          <ProcessingIconStatus />
          <strong>Em processamento</strong>
        </div>
      );
    }
  };

  return <div>{renderBadget()}</div>;
};

export default StatusPill;
